import ApolloClient from 'apollo-boost';

const CONTENT_DELIVERY_SERVICE_BASE_URL = `${process.env.REACT_APP_API_GATEWAY_URL}/v1/cdn/graphql`;

export const client = new ApolloClient({
    uri: CONTENT_DELIVERY_SERVICE_BASE_URL,
    headers: {
        institutionuuid: process.env.REACT_APP_INSTITUTION_UUID,
    },
});
